import React from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import {useTranslation} from "react-i18next";
import ChangeSettings from "./ChangeSettings";
import Title from "../../../components/elements/Title";


function ChangeSettingsPage({type}){
    const { t } = useTranslation();

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('changeSettings')}>
            <Grid container spacing={2} justify="center">
                <Grid item size={12}>
                    <ChangeSettings/>
                </Grid>
            </Grid>
        </AppAnimate>
    );
}
export default withStyles(Styles)(ChangeSettingsPage);
